<template>
  <div class="page-container">
    <h1 class="page-title">联系我们</h1>
    
    <div class="content-section">
      <div class="contact-grid">
        <div class="contact-card">
          <div class="contact-icon">
            <i class="icon-address"></i>
          </div>
          <h3 class="contact-title">公司地址</h3>
          <p class="contact-info">新疆乌鲁木齐市经济技术开发区(头屯河区)通达街767号安澜大厦公寓1516室</p>
        </div>
        
        <div class="contact-card">
          <div class="contact-icon">
            <i class="icon-phone"></i>
          </div>
          <h3 class="contact-title">联系电话</h3>
          <p class="contact-info">总机：15160945581</p>
        </div>
        
        <div class="contact-card">
          <div class="contact-icon">
            <i class="icon-email"></i>
          </div>
          <h3 class="contact-title">电子邮箱</h3>
          <p class="contact-info">客服邮箱：2756825623@qq.com</p>
          <p class="contact-info">商务合作：2756825623@qq.com</p>
        </div>
        
        <div class="contact-card">
          <div class="contact-icon">
            <i class="icon-time"></i>
          </div>
          <h3 class="contact-title">工作时间</h3>
          <p class="contact-info">周一至周五：9:00-18:00</p>
          <p class="contact-info">客服热线：9:00-22:00（全年无休）</p>
        </div>
      </div>
    </div>
    
    <!-- <div class="content-section">
      <h2 class="section-title">留言反馈</h2>
      <div class="feedback-form">
        <div class="form-group">
          <label for="name">姓名</label>
          <input type="text" id="name" v-model="feedbackForm.name" placeholder="请输入您的姓名">
        </div>
        
        <div class="form-group">
          <label for="contact">联系方式</label>
          <input type="text" id="contact" v-model="feedbackForm.contact" placeholder="请输入您的手机号或邮箱">
        </div>
        
        <div class="form-group">
          <label for="type">留言类型</label>
          <select id="type" v-model="feedbackForm.type">
            <option value="">请选择留言类型</option>
            <option value="suggestion">产品建议</option>
            <option value="complaint">投诉反馈</option>
            <option value="cooperation">商务合作</option>
            <option value="other">其他问题</option>
          </select>
        </div>
        
        <div class="form-group">
          <label for="content">留言内容</label>
          <textarea id="content" v-model="feedbackForm.content" placeholder="请输入您的留言内容（不超过500字）" rows="5"></textarea>
        </div>
        
        <button class="submit-btn" @click="submitFeedback">提交留言</button>
      </div>
    </div> -->
    
    <div class="content-section">
      <h2 class="section-title">公司位置</h2>
      <div class="map-container">
        <div class="map-placeholder">
          <!-- <p>地图加载中...</p>
          <p>新疆乌鲁木齐市经济技术开发区(头屯河区)通达街767号安澜大厦公寓1516室</p> -->
              <img src="../assets/map.png" alt="公司位置" class="map-image">
        </div>
      </div>
    </div>
    
    <!-- <div class="content-section">
      <h2 class="section-title">关注我们</h2>
      <div class="social-media">
        <div class="social-item">
          <div class="qrcode-placeholder"></div>
          <p class="social-name">官方微信</p>
        </div>
        <div class="social-item">
          <div class="qrcode-placeholder"></div>
          <p class="social-name">官方微博</p>
        </div>
        <div class="social-item">
          <div class="qrcode-placeholder"></div>
          <p class="social-name">抖音号</p>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'ContactUs',
  data() {
    return {
      feedbackForm: {
        name: '',
        contact: '',
        type: '',
        content: ''
      }
    }
  },
  methods: {
    submitFeedback() {
      // 这里可以添加表单验证逻辑
      if (!this.feedbackForm.name) {
        alert('请输入您的姓名');
        return;
      }
      
      if (!this.feedbackForm.contact) {
        alert('请输入您的联系方式');
        return;
      }
      
      if (!this.feedbackForm.type) {
        alert('请选择留言类型');
        return;
      }
      
      if (!this.feedbackForm.content) {
        alert('请输入留言内容');
        return;
      }
      
      // 模拟提交
      alert('感谢您的留言，我们会尽快与您联系！');
      
      // 重置表单
      this.feedbackForm = {
        name: '',
        contact: '',
        type: '',
        content: ''
      };
    }
  }
}
</script>

<style scoped>
.page-container {
  padding: 20px;
  max-width: 1000px;
  margin: 0 auto;
  padding-bottom: 40px;
}

.page-title {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 30px;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.content-section {
  margin-bottom: 40px;
}

.section-title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 20px;
  color: #333;
}

.contact-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.contact-card {
  background-color: #f9f9f9;
  border-radius: 4px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.contact-icon {
  width: 50px;
  height: 50px;
  background-color: #f0f5ff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
}

.icon-address, .icon-phone, .icon-email, .icon-time {
  width: 24px;
  height: 24px;
  background-color: #4169e1;
  border-radius: 50%;
}

.contact-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
  color: #333;
}

.contact-info {
  font-size: 14px;
  line-height: 1.6;
  color: #666;
  margin-bottom: 5px;
}

.feedback-form {
  background-color: #f9f9f9;
  border-radius: 4px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 5px;
  color: #333;
}

.form-group input, .form-group select, .form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
}

.form-group textarea {
  resize: vertical;
}

.submit-btn {
  background-color: #4169e1;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-btn:hover {
  background-color: #3a5ecc;
}

.map-container {
  height: 300px;
  background-color: #f9f9f9;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.map-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

  .map-placeholder {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}

.social-media {
  display: flex;
  justify-content: center;
  gap: 30px;
}

.social-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qrcode-placeholder {
  width: 120px;
  height: 120px;
  background-color: #f9f9f9;
  border: 1px solid #eee;
  margin-bottom: 10px;
}

.social-name {
  font-size: 14px;
  color: #333;
}

@media (max-width: 768px) {
  .contact-grid {
    grid-template-columns: 1fr;
  }
  
  .social-media {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
}
</style> 